import React from 'react'
import { FieldLabel } from './'
import styled from 'styled-components'
import { I18n } from 'react-redux-i18n'
import { Button } from 'react-bootstrap'
import { uploadImage, removeImage } from '../../api'
import { connect } from 'react-redux'
import { urlWithTimeQuery } from '../table'
import { toastr } from 'react-redux-toastr'

// Backend converts these to PNG; keep in sync with coral-be uploadImageHelper
const acceptedImageTypes = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
]
const maxImageSize = 5 * 1024 * 1024

export default (props) => (
  <FieldLabel {...props} component={ImageUploadContainer} />
)

const ImageUpload = ({
  value,
  onChange,
  name,
  height,
  width,
  uploadURL,
  emptyLabel,
  jwt,
  ...props
}) => {
  const { upload, remove } = I18n.t('action')
  return (
    <div>
      <div className="text-center">
        <ImageUploadToolbar>
          <span className="btn btn-default btn-file">
            {upload.toUpperCase()}{' '}
            <input
              type="file"
              accept={acceptedImageTypes.join(',')}
              onChange={makeUploadImageHandler(uploadURL, value, onChange, jwt)}
            />
          </span>
          <Button
            onClick={makeRemoveImageHandler(uploadURL, value, onChange, jwt)}
          >
            {remove.toUpperCase()}
          </Button>
        </ImageUploadToolbar>
        <LogoPreviewContainer src={value} alt={name} />
      </div>
    </div>
  )
}

const ImageUploadContainer = connect(({ auth }) => ({ jwt: auth.jwt }))(
  ImageUpload,
)

class LogoPreviewContainer extends React.Component {
  state = {
    src: urlWithTimeQuery(this.props.src) || '/assets/images/no_image.png',
  }

  updateImageSource(src = this.props.src) {
    this.setState({
      src: urlWithTimeQuery(src) || '/assets/images/no_image.png',
    })
  }

  handleError = () => {
    this.updateImageSource(null)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.updateImageSource(nextProps.src)
    }
  }

  render() {
    return (
      <LogoPreview
        src={this.state.src}
        onError={this.handleError}
        alt={this.props.alt}
      />
    )
  }
}

const LogoPreview = styled.img.attrs({ className: 'img-responsive' })`
  padding: 10px;
  margin: 0 auto;
  margin-top: 10px;
  background-size: contain;
  border: 2px solid #72421a;
  border-radius: 15px;
  height: 200px;
  width: auto;
`

const makeUploadImageHandler =
  (uploadURL, imageURL, handleImageChange, jwt) => (event) => {
    const file = event.target.files && event.target.files[0]
    event.target.value = '' // allow re-selecting the same file
    if (!file) return

    const { title, invalidType, tooLarge, failed } = I18n.t('imageUpload')
    if (!acceptedImageTypes.includes(file.type))
      return toastr.error(title, invalidType)
    if (file.size > maxImageSize) return toastr.error(title, tooLarge)

    handleImageChange(null)
    uploadImage(uploadURL, file, jwt)
      .then((url) => handleImageChange(url))
      .catch(() => {
        handleImageChange(imageURL)
        toastr.error(title, failed)
      })
  }

const makeRemoveImageHandler =
  (uploadURL, imageURL, handleImageChange, jwt) => () => {
    removeImage(uploadURL, jwt).then((response) => {
      if (response.ok) handleImageChange(null)
    })
  }

const ImageUploadToolbar = styled(({ className, children }) => (
  <div className={className}>{children}</div>
))`
  > * {
    margin-left: 7px;
    margin-right: 7px;
  }
`
